import React from 'react'
import { SidebarAgenda } from './SidebarAgenda'
import {Tasks} from '../Tasks'

export const ContentAgenda = () => (
<section className='content'>
    <SidebarAgenda />
    <Tasks />
</section>

)
